/**
 * Cobo 订单抑制态（与 RPC session / 弹窗内存 coboOrderWatch 分离）
 * - notBeforeMs：关窗时刻；再开后只认创建时间 ≥ 该值的新单（防 orders 再拉出旧单）
 * - seenOrderIds / seenTx：已展示或已关窗确认过的单
 */

export const COBO_ORDER_SUPPRESS_KEY = 'deposit-cobo-order-suppress-v1';

function normalizeIdList(list) {
  return [
    ...new Set(
      (Array.isArray(list) ? list : [])
        .map((id) => String(id ?? '').trim())
        .filter(Boolean)
    ),
  ];
}

function normalizeTxList(list) {
  return [
    ...new Set(
      (Array.isArray(list) ? list : [])
        .map((tx) => String(tx ?? '').trim().toLowerCase())
        .filter(Boolean)
    ),
  ];
}

export function loadCoboOrderSuppress() {
  if (typeof sessionStorage === 'undefined') {
    return { seenOrderIds: [], seenTx: [], notBeforeMs: 0 };
  }
  try {
    const raw = sessionStorage.getItem(COBO_ORDER_SUPPRESS_KEY);
    if (!raw) return { seenOrderIds: [], seenTx: [], notBeforeMs: 0 };
    const parsed = JSON.parse(raw);
    return {
      seenOrderIds: normalizeIdList(parsed?.seenOrderIds),
      seenTx: normalizeTxList(parsed?.seenTx),
      notBeforeMs: Math.max(0, Number(parsed?.notBeforeMs) || 0),
    };
  } catch {
    return { seenOrderIds: [], seenTx: [], notBeforeMs: 0 };
  }
}

export function saveCoboOrderSuppress(state) {
  if (typeof sessionStorage === 'undefined') return;
  const next = {
    seenOrderIds: normalizeIdList(state?.seenOrderIds),
    seenTx: normalizeTxList(state?.seenTx),
    notBeforeMs: Math.max(0, Number(state?.notBeforeMs) || 0),
  };
  try {
    sessionStorage.setItem(COBO_ORDER_SUPPRESS_KEY, JSON.stringify(next));
  } catch {
    // ignore quota
  }
}

/** 合并 seen，并可选抬高 notBeforeMs（只增不减） */
export function mergeCoboOrderSuppress({
  orderIds = [],
  txHashes = [],
  notBeforeMs = null,
} = {}) {
  const prev = loadCoboOrderSuppress();
  const nextNotBefore =
    notBeforeMs == null
      ? prev.notBeforeMs
      : Math.max(prev.notBeforeMs, Math.max(0, Number(notBeforeMs) || 0));
  const next = {
    seenOrderIds: normalizeIdList([...prev.seenOrderIds, ...orderIds]),
    seenTx: normalizeTxList([...prev.seenTx, ...txHashes]),
    notBeforeMs: nextNotBefore,
  };
  saveCoboOrderSuppress(next);
  return next;
}

export function clearCoboOrderSuppress() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(COBO_ORDER_SUPPRESS_KEY);
  } catch {
    // ignore
  }
}
